import { render, staticRenderFns } from "./AudienceSegmentationComponent.vue?vue&type=template&id=cd74b260"
import script from "./AudienceSegmentationComponent.vue?vue&type=script&lang=ts"
export * from "./AudienceSegmentationComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports